import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';

function Sidebar({ setView, onLogout, currentUser }) {
  const [adminOpen, setAdminOpen] = useState(false);
  const [loanOpen, setLoanOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeView, setActiveView] = useState('dashboard');

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleView = (view) => {
    setView(view);
    setActiveView(view);
    if (isMobile) setIsOpen(false);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleAdminMenu = () => {
    setAdminOpen(!adminOpen);
  };

  const toggleLoanMenu = () => {
    setLoanOpen(!loanOpen);
  };

  const toggleAccountMenu = () => {
    setAccountOpen(!accountOpen);
  };

  return (
    <>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <img src={logo} alt="Logo" className="sidebar-logo" />

        {!sidebarCollapsed && (
          <ul className="sidebar-menu">
            <li className={activeView === 'dashboard' ? 'active' : ''}>
              <a href="#" onClick={() => handleView('dashboard')}>Home</a>
            </li>

            {currentUser?.role === 'superadmin' && (
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleAdminMenu();
                  }}
                  className={adminOpen ? '' : 'collapsed'}
                >
                  Admin Settings
                  <span className="toggle-icon">▾</span>
                </a>
                <ul className={`sidebar-submenu ${adminOpen ? '' : 'collapsed'}`}>
                  <li className={activeView === 'user-registration' ? 'active' : ''}>
                    <a href="#" onClick={() => handleView('user-registration')}>User Registration</a>
                  </li>
                  <li className={activeView === 'user-management' ? 'active' : ''}>
                    <a href="#" onClick={() => handleView('user-management')}>User Management</a>
                  </li>
                </ul>
              </li>
            )}

            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleLoanMenu();
                }}
                className={loanOpen ? '' : 'collapsed'}
              >
                Loan Tracker
                <span className="toggle-icon">▾</span>
              </a>
              <ul className={`sidebar-submenu ${loanOpen ? '' : 'collapsed'}`}>
                <li className={activeView === 'loan-viewer' ? 'active' : ''}>
                  <a href="#" onClick={() => handleView('loan-viewer')}>Loan Viewer</a>
                </li>
                <li className={activeView === 'account-disbursed' ? 'active' : ''}>
                  <a href="#" onClick={() => handleView('account-disbursed')}>Account Disbursed</a>
                </li>
                {currentUser?.role === 'superadmin' && (
                    <>
                      <li className={activeView === 'loan-archive' ? 'active' : ''}>
                        <a href="#" onClick={() => handleView('loan-archive')}>Archived Loans</a>
                      </li>
                      <li className={activeView === 'loan-export' ? 'active' : ''}>
                        <a href="#" onClick={() => handleView('loan-export')}>Export Loans</a>
                      </li>
                    </>
                  )}
                                


              </ul>

            </li>

            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleAccountMenu();
                }}
                className={accountOpen ? '' : 'collapsed'}
              >
                Account Settings
                <span className="toggle-icon">▾</span>
              </a>
              <ul className={`sidebar-submenu ${accountOpen ? '' : 'collapsed'}`}>
                <li className={activeView === 'change-password' ? 'active' : ''}>
                  <a href="#" onClick={() => handleView('change-password')}>Change Password</a>
                </li>
                <li className={activeView === 'user-info' ? 'active' : ''}>
                  <a href="#" onClick={() => handleView('user-info')}>User Information</a>
                </li>
              </ul>
            </li>

            <li>
              <a href="#" onClick={onLogout} style={{ color: '#ffcdd2' }}>🔓 Logout</a>
            </li>
          </ul>
        )}

<button
        className="collapse-toggle desktop-toggle"
        onClick={toggleSidebar}
        title={isOpen ? "Hide Sidebar" : "Show Sidebar"}
      >
        {isOpen ? '×' : '☰'}
      </button>



      </div>

      {isMobile && (
        <button className="collapse-toggle" onClick={toggleSidebar}>
          {isOpen ? '×' : '☰'}
        </button>
      )}
    </>
  );
}

export default Sidebar;
